import { Link, useNavigate } from "react-router-dom";
import { IconButton } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ChangesHistory from "../../../components/History";
import TableButtons from "../../../components/TableComponents/TableButtons";
import { removeDriver } from "../../../redux/module/driver";
import useAppDispatch from "../../../hooks/useAppDispatch";
import { deleteRoute } from "../../../redux/module/route";
import { Button } from "@mui/base";
import { Download } from "@mui/icons-material";
import { downloadFile } from "../../../distflowAPI/downloadFile";

const DAYS_LIST = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "sunday",
];

const route_name = {
  headerName: "Name",
  colId: "name",
  wrapText: true,
  autoHeight: true,
  filter: false,
  floatingFilter: false,
  valueGetter: (params) => {
    return `${params.data.name}`;
  },
  minWidth: 120,
  maxWidth: 150,
};

const is_active = {
  headerName: "Is Active",
  wrapText: true,
  colId: "is_active",
  autoHeight: true,
  filter: false,
  floatingFilter: false,
  valueGetter: (params) => {
    return params.data.active ? "Yes" : "No";
  },
  minWidth: 80,
  maxWidth: 130,
};

const driver = {
  headerName: "Driver",
  colId: "driver",
  wrapText: true,
  autoHeight: true,
  filter: false,
  floatingFilter: false,
  valueGetter: (params) => {
    return `${params.data.driver.user.first_name} ${params.data.driver.user.last_name}`;
  },
  minWidth: 120,
  maxWidth: 200,
};

const accounts = {
  headerName: "Accounts",
  colId: "accounts",
  wrapText: true,
  autoHeight: true,
  filter: false,
  floatingFilter: false,
  valueGetter: (params) => {
    return `${params.data.route_accounts.length}`;
  },
  minWidth: 130,
  maxWidth: 130,
};

const vendors = {
  headerName: "Vendors",
  colId: "vendors",
  wrapText: true,
  autoHeight: true,
  filter: false,
  floatingFilter: false,
  valueGetter: (params) => {
    return `${params.data.route_vendors.length}`;
  },
  minWidth: 130,
  maxWidth: 130,
};

const days = {
  headerName: "Days",
  colId: "days",
  wrapText: true,
  autoHeight: true,
  filter: false,
  floatingFilter: false,
  valueGetter: (params) => {
    const active_days = DAYS_LIST.filter((item) => params.data[item] == true);
    return active_days.join(", ");
  },
  minWidth: 200,
};

const RenderRouteLink = (props) => {
  const dispatch = useAppDispatch();

  const handleDelete = async () => {
    await dispatch(deleteRoute(props.data.id));
  };
  return (
    <>
      <TableButtons
        link={`/routes2/routes/${props.data.id}`}
        handleDelete={handleDelete}
        deletePopupEntity="route"
        historyData={props.data.history || []}
        extraButtons={[
          <IconButton
            onClick={() =>
              downloadFile(
                `/api/routes2/routes/${props.data.id}/download/`,
                `route-${props.data.id}.csv`,
                false
              )
            }
          >
            <Download />
          </IconButton>,
        ]}
      />
    </>
  );
};

const route_link = {
  field: "",
  sorting: false,
  sort: false,
  sortable: false,
  autoHeight: true,
  filter: false,
  cellRenderer: RenderRouteLink,
  minWidth: 160,
  maxWidth: 160,
};
const routeTableColumns = [
  route_name,
  is_active,
  driver,
  accounts,
  vendors,
  days,
  route_link,
];

export default routeTableColumns;
